// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__SmuAl","author":"Table_author__7IlCl","authorImage":"Table_authorImage__1zGYI","unreadRow":"Table_unreadRow__3KAnU"};